//-------------------------------------------------------------------------------------------------- Imports
import { useEffect, useRef } from "react";

//-------------------------------------------------------------------------------------------------- Component
// El sello de Sysnet (script assurancecard en public/index.html) se inserta en el body.
// Este componente lo coloca en su posición y lo regresa al body al desmontarse.
// En móvil se muestra en línea; en escritorio sigue flotando a la derecha (ver index.css).
const SecuritySeal = () => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const seal = document.getElementById("widget-preview");
        const container = containerRef.current;
        if (!seal || !container) return;
        container.appendChild(seal);
        return () => {
            document.body.appendChild(seal);
        };
    }, []);

    return <div ref={containerRef} />;
};

//-------------------------------------------------------------------------------------------------- Exports
export default SecuritySeal;
